import * as React from "react";
const SvgVerticalStick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 1, height: 30, viewBox: "0 0 1 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 1, height: 30 }));
export { SvgVerticalStick as ReactComponent };
